var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState } from 'react';
import styled from 'styled-components';
import ReactDatepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { InputText } from '..';
var StyledReactDatepicker = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: inherit;\n  display: flex;\n  flex-grow: 1;\n\n  & > .react-datepicker-wrapper {\n    border-radius: inherit;\n    display: flex;\n    flex-grow: 1;\n\n    & > .react-datepicker__input-container {\n      border-radius: inherit;\n      display: flex;\n      flex-grow: 1;\n    }\n  }\n"], ["\n  border-radius: inherit;\n  display: flex;\n  flex-grow: 1;\n\n  & > .react-datepicker-wrapper {\n    border-radius: inherit;\n    display: flex;\n    flex-grow: 1;\n\n    & > .react-datepicker__input-container {\n      border-radius: inherit;\n      display: flex;\n      flex-grow: 1;\n    }\n  }\n"])));

var DatepickerInput = function DatepickerInput(_a) {
  var inputRef = _a.inputRef,
      name = _a.name,
      props = __rest(_a, ["inputRef", "name"]);

  return React.createElement(InputText, Object.assign({
    inputRef: inputRef,
    name: name
  }, props));
};

var Datepicker = function Datepicker(_a) {
  var _onChange = _a.onChange,
      inputRef = _a.inputRef,
      name = _a.name,
      selected = _a.selected,
      props = __rest(_a, ["onChange", "inputRef", "name", "selected"]);

  var _b = useState(selected ? selected : new Date()),
      current = _b[0],
      onSelect = _b[1];

  return React.createElement(StyledReactDatepicker, null, React.createElement(ReactDatepicker, Object.assign({
    className: "datepicker",
    customInput: React.createElement(DatepickerInput, {
      inputRef: inputRef,
      name: name
    }),
    name: name,
    onChange: function onChange(date, e) {
      if (date) {
        onSelect(date);
      }

      _onChange && _onChange(date, e);
    },
    selected: current
  }, props)));
};

export default Datepicker;
var templateObject_1;